import NLS                  from "Dashboard/Core/NLS";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { ContactSocial }    from "Utils/API";



// The initial State
const initialState = {
    loading   : true,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canFilter : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    statuses  : [],
    sort      : {
        orderBy  : "position",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "CONTACT_SOCIAL_LOADING" });
    },

    /**
     * Fetches the Contact Social List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await ContactSocial.getAll(params);
        data.sort  = params;
        dispatch({ type : "CONTACT_SOCIAL_LIST", data });
    },

    /**
     * Fetches a single Contact Social
     * @param {Function} dispatch
     * @param {Number}   contactSocialID
     * @returns {Promise}
     */
    async fetchElem(dispatch, contactSocialID) {
        const data = await ContactSocial.getOne({ contactSocialID });
        dispatch({ type : "CONTACT_SOCIAL_ELEM", data });
        return data;
    },

    /**
     * Fetches the Contact Social Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await ContactSocial.getEditData();
        dispatch({ type : "CONTACT_SOCIAL_EDIT", data });
    },

    /**
     * Edits/Creates a Contact Social
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return ContactSocial.edit(data);
    },

    /**
     * Deletes the Contact Social
     * @param {Function} dispatch
     * @param {Number}   contactSocialID
     * @returns {Promise}
     */
    deleteElem(dispatch, contactSocialID) {
        return ContactSocial.delete({ contactSocialID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.socialTypeName = NLS.get("SELECT_SOCIAL_TYPES", elem.socialType);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "CONTACT_SOCIAL_LIST", "CONTACT_SOCIAL_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "CONTACT_SOCIAL_LOADING":
        return {
            ...state,
            loading   : true,
        };

    case "CONTACT_SOCIAL_LIST":
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canFilter : action.data.canFilter,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : Utils.parseList(action.data.list, parseElem),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case "CONTACT_SOCIAL_ELEM":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            elem      : parseElem(action.data.elem),
            statuses  : action.data.statuses,
        };

    case "CONTACT_SOCIAL_EDIT":
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            statuses  : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
